module.exports = __webpack_public_path__ + "static/wtv-f656003589de4e89bbcd4ec7a3759f3f.gif";